<template>
<div id="sheets-statistics">
  <div class="row">
    <div class="col-xs-12">
        <h1 class="text-primary">
          <small >
            <span v-if="!isNational">
              {{ region }}
            </span>
            <span v-else>
              Programme National
            </span>
            {{ year }}
          </small>
          <br>
          Statistiques
        </h1>
        <hr>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class="panel panel-info">
        <div class="panel-heading">
          <div v-show="refreshing">
            Récupération des données...
          </div>
          <div v-show="!refreshing">
            <div class="form-inline">
              <dropdown class="form-group">
                <div class="input-group">
                  <input class="form-control"
                         type="text"
                         v-model="endDateDisplay"
                         disabled>
                  <div class="input-group-btn">
                    <btn class="dropdown-toggle"><i class="glyphicon glyphicon-calendar"></i></btn>
                  </div>
                </div>
                <template slot="dropdown">
                  <li>
                    <date-picker v-model="endDate"
                                 :today-btn="false"
                                 :clear-btn="false"
                                 format="MM/dd/yyyy" />
                  </li>
                </template>
              </dropdown>
              <div class="form-group">
                <div class="input-group">
                  <input required
                         ref="input"
                         id="input"
                         tabindex="0"
                         class="form-control"
                         v-model="text"
                         type="text"
                         placeholder="Taper le finess ou le nom"
                         autocomplete="off"/>
                  <div class="input-group-addon">
                    <a role="button" @click="establishment = null">
                      Effacer
                    </a>
                  </div>
                </div>
                <typeahead v-model="establishment"
                           open-on-focus
                           force-select
                           target="#input"
                           :data="establishmentList"
                           item-key="value"/>
              </div>
              <div class="form-group">
                <btn @click="refreshData"
                     class="form-group" type="warning"
                     :disabled="refreshing">Rafraîchir</btn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr>
    </div>
  </div>
  <div v-if="!refreshing">
    <div class="row">
      <div class="col-xs-12">
        <div v-if="error.error">
          <alert type="danger">
            {{ error.text }}
          </alert>
        </div>
        <div v-else-if="establishment != null">
          <h3 class="text-primary">{{ selection.establishment.name }}</h3>
          <table class="table table-responsive">
            <tbody>
              <tr v-for="d in details"
                  :key="`sheets-statistics-details-${d.key}`">
                <td>{{ d.title }}</td>
                <td v-if="d.html" v-html="d.value"></td>
                <td v-else><strong>{{ d.value }}</strong></td>
              </tr>
            </tbody>
          </table>
          <div class="row">
            <div v-for="(c, i) in detailCharts"
                 :key="c.key">
              <div class="col-xs-12 col-md-6 chart-container">
                <template v-for="(cfg, j) in [_self[c.property]]">
                  <div :key="`chart-${i}-${j}`">
                    <span v-if="cfg.type">
                      <chart
                        :key="`detail-chart-${c.key}-${j}`"
                        :type="`${cfg.type}-chart`"
                        :config="cfg.config"
                        :plugins="cfg.plugins"
                        :exportConfig="cfg.exportConfig">
                      </chart>
                    </span>
                    <span v-else>
                      <chart :type="`${c.type}-chart`"
                             :config="cfg"></chart>
                    </span>
                  </div>
                </template>
              </div>
              <div class="clearfix hidden-xs hidden-sm"
                   v-if="i % 2 === 1"></div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="row">
            <div v-for="(c, i) in charts"
                 :key="c.key">
              <div class="col-xs-12 col-md-6 col-lg-4 chart-container">
                <template v-for="(cfg, j) in [_self[c.property]]">
                  <div :key="`chart-${i}-${j}`">
                    <span v-if="cfg.type">
                      <chart
                        :key="`chart-${i}-${j}`"
                        :type="`${cfg.type}-chart`"
                        :config="cfg.config"
                        :plugins="cfg.plugins"
                        :exportConfig="cfg.exportConfig">
                      </chart>
                    </span>
                    <span v-else>
                      <chart :type="`${c.type}-chart`"
                              :config="cfg"></chart>
                    </span>
                  </div>
                </template>
              </div>
              <div class="clearfix hidden-xs hidden-sm hidden-lg"
                   v-if="i % 2 === 1"></div>
              <div class="clearfix hidden-xs hidden-sm hidden-md"
                   v-if="i % 3 === 2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import impl from '@/views/sheets/impl/statistics'
import modules from '@/sui/data/modules'
import chart from '@/sui/components/charts/chart'
import regions from '@/sui/tools/regions'
import ice from '@/sui/tools/ice'
import moment from 'moment'

export default {
  name: 'sheets-statistics',

  data: function () {
    return {
      endDate: '',
      refreshing: false,
      establishment: null,
      text: '',
      error: {
        error: false,
        text: ''
      },
      detailCharts: [
        {
          key: 'chart-selection-evolution',
          type: 'line',
          property: 'selectionEvolution'
        },
        {
          key: 'chart-selection-protocol-dist',
          property: 'selectionProtocolDistribution'
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
      getListByName: 'surveillances/listByName',
      loginState: 'login/loginState',
      loginRegion: 'login/region'
    }),

    ...mapState({
      all: state => state.surveillances.all,
      sheets: state => state.bosheet.all
    }),

    isNational: function () {
      return this.$route.path.match(/^\/mission/)
    },

    region: function () {
      if (this.isNational || this.loginRegion == null) {
        return null
      }

      return regions.regions[this.loginRegion].name
    },

    endDateDisplay: function () {
      const d = moment(this.endDate).format(`DD/MM/YYYY`)
      return `01/12/${this.year - 1} - ${d}`
    },

    charts: function () {
      if (!this.loginState.isLoggedIn) {
        return []
      }

      const charts = [
        {
          key: 'chart-evolution',
          type: 'line',
          property: 'evolution'
        },
        {
          key: 'chart-protocol-dist',
          property: 'protocolDistribution'
        },
        {
          key: 'chart-establishment-count',
          property: 'establishmentCount'
        },
        {
          key: 'chart-protocol-radar',
          type: 'radar',
          property: 'protocolRadar'
        },
        {
          key: 'chart-sheet-avg',
          property: 'sheetByEstablishment'
        },
        {
          key: 'chart-size-dist',
          property: 'establishmentSizeDistribution'
        },
        {
          key: 'chart-bact-dist',
          property: 'bactSheetsDistribution'
        }
      ]

      if (this.loginState.isUser) {
        charts.push(
          {
            key: 'chart-region-sheet',
            property: 'regionalDistribution'
          },
          {
            key: 'chart-region-surveillances',
            property: 'regionalEstablishmentDistribution'
          }
        )
      }
      return charts
    },

    surveillances: function () {
      return this.all[this.year]
    },

    establishmentList: function () {
      return this.getListByName(this.year)
    },

    year: function () {
      return this.$route.params.year
    },

    details: function () {
      const s = this.selection
      if (s == null) {
        return []
      }

      const e = s.establishment
      const r = s.registrator
      let convention = ''
      switch (s.cvt.stat) {
        case 2:
          convention = 'Validée'
          break
        case 3:
          const e = s.cvt.error === '[UpdatedRegistrator]'
            ? 'Changement de réferent' : s.cvt.error
          convention = `Refusée (${e})`
          break
        case 1:
          convention = 'En attente de validation'
          break
        case 4:
          convention = 'Modifié'
          break
        default:
          convention = 'Absente'
      }

      const p = s.modules
      let htmlP = ''
      for (let t in p) {
        if (p[t] != null && modules[this.year][t].sheets != null) {
          htmlP +=
            `<span class='label label-${t}' style='margin-right: 1rem'>
                 <strong>${modules[this.year][t].label}</strong>
             </span>`
        }
      }

      const result = [
        {
          key: 'finess',
          title: 'Finess',
          value: e.finess
        },
        {
          key: 'ref',
          title: 'Responsable',
          value: `${r.firstName} ${r.name} (${r.emails})`
        },
        {
          key: 'chart',
          title: 'Charte',
          value: convention
        },
        {
          key: 'protocols',
          title: 'Protocoles',
          html: true,
          value: htmlP
        }
      ]
      if (s.year === 2019) {
        result.push(
          {
            key: 'status',
            title: 'Statut de la surveillance',
            value: s.isClosed() ? 'Clôturée' : 'Ouverte'
          }
        )
      }

      return result
    },

    selection: function () {
      if (this.establishment == null) {
        return null
      }

      return this.establishment.surveillance
    },

    protocolStats: function () {
      const result = {}
      impl.protocols[this.year].forEach(
        p => {
          result[p] = 0
        }
      )

      this.surveillances.forEach(
        s => {
          const protocols = s.modules
          impl.protocols[this.year].forEach(
            p => {
              if (protocols[p] != null) {
                result[p] += 1
              }
            }
          )
        }
      )
      return result
    },

    selectionFlatList: function () {
      if (this.selection == null) {
        return null
      }

      const protocolDistribution = []
      impl.protocols[this.year].forEach(() => { protocolDistribution.push(0) })
      const reducer = (result, u) => {
        if (u.surveillance === this.selection.id) {
          const p = impl.protocols[this.year].indexOf(u.protocol)
          result.protocolDistribution[p] += u.count
          let day = result.evolution.find(e => e.date === u.day)
          if (day == null) {
            day = {
              date: u.day,
              data: { total: 0 }
            }
            for (let p in impl.protocols[this.year]) {
              day.data[impl.protocols[this.year][p]] = 0
            }
            result.evolution.push(day)
          }
          day.data.total += u.count
          day.data[u.protocol] += u.count
        }
        return result
      }

      const initial = {
        protocolDistribution: protocolDistribution,
        evolution: []
      }
      const result = this.sheets.reduce(reducer, initial)
      const evolution = result.evolution.sort(
        (a, b) => {
          return new Date(a.date) - new Date(b.date)
        }
      )
      result.evolution = evolution
      return result
    },

    flatList: function () {
      const protocolDistribution = []
      const establishments = {
        total: []
      }

      for (let i = 0; i !== impl.protocols[this.year].length; ++i) {
        protocolDistribution.push(0)
        establishments[impl.protocols[this.year][i]] = []
      }

      const regionalDistribution = {
        data: [],
        establishments: [],
        labels: []
      }
      for (let r in regions.regions) {
        regionalDistribution.data.push(0)
        regionalDistribution.establishments.push(0)
        regionalDistribution.labels.push(regions.regions[r].name)
      }

      const sheetCounts = []
      let emptyBactADICount = 0
      this.surveillances.forEach(
        (s) => {
          const count = {}
          impl.protocols[this.year].forEach(p => { count[p] = 0 })
          sheetCounts.push(count)
          if (s.emptyBactADI) {
            emptyBactADICount++
          }
        }
      )

      const initial = {
        protocolDistribution: protocolDistribution,
        regionalDistribution: regionalDistribution,
        establishments: establishments,
        sheetCounts: sheetCounts,
        evolution: [],
        bactADI: []
      }

      const reducer = (result, u) => {
        let i = null
        if (u.surveillance === 'random') {
          const count = this.surveillances.length
          const index = Math.floor(Math.random() * count)
          i = index === count ? count - 1 : index
        } else {
          i = this.surveillances.findIndex(e => e.id === u.surveillance)
          if (i === -1) {
            return result
          }
        }

        const p = impl.protocols[this.year].indexOf(u.protocol)
        let day = result.evolution.find(e => e.date === u.day)
        if (day == null) {
          day = {
            date: u.day,
            data: { total: 0 }
          }
          for (let p in impl.protocols[this.year]) {
            day.data[impl.protocols[this.year][p]] = 0
          }
          result.evolution.push(day)
        }
        day.data.total += u.count
        day.data[u.protocol] += u.count

        const s = this.surveillances[i]
        result.protocolDistribution[p] += u.count
        const f = s.establishment.finess
        const r = regions.indexOf(f)
        result.regionalDistribution.data[r] += u.count
        if (result.establishments.total.indexOf(i) === -1) {
          result.establishments.total.push(i)
          result.regionalDistribution.establishments[r] += 1
        }

        if (result.establishments[u.protocol].indexOf(i) === -1) {
          result.establishments[u.protocol].push(i)
        }

        result.sheetCounts[i][u.protocol] += u.count

        result.bactADI[i] = s.hasProtocol('bactADI')

        return result
      }

      const result = this.sheets.reduce(reducer, initial)
      const establishmentsBuckets = []
      impl.buckets.forEach(() => establishmentsBuckets.push(0))
      establishmentsBuckets.push(0)

      for (let i in result.sheetCounts) {
        const all = result.sheetCounts[i]
        let count = 0
        for (let j in all) {
          count += all[j]
        }

        let k = 0
        for (let j in impl.buckets) {
          if (count < impl.buckets[j]) {
            break
          }
          ++k
        }
        establishmentsBuckets[k] += 1
      }

      const bactSheetsBuckets = []
      impl.bactLabels.forEach(() => bactSheetsBuckets.push(0))
      for (let i in this.surveillances) {
        const s = this.surveillances[i]
        if (s.hasProtocol('bactADI')) {
          const count = result.sheetCounts[i].bactADI
          if (s.emptyBactADI) {
            bactSheetsBuckets[0] += 1
          } else if (count === 0) {
            bactSheetsBuckets[1] += 1
          } else {
            bactSheetsBuckets[2] += 1
          }
        }
      }

      const evolution = result.evolution.sort(
        (a, b) => {
          return new Date(a.date) - new Date(b.date)
        }
      )
      const protocolRadar = {}
      impl.protocols[this.year].forEach(
        p => {
          const b = (p === 'bactADI') ? emptyBactADICount : 0
          const e = result.establishments[p].length + b
          const d = result.protocolDistribution[impl.protocols[this.year].indexOf(p)]
          let t = 0
          for (let i in result.evolution) {
            if (result.evolution[i].data[p] > 0) {
              t += 1
            }
          }
          protocolRadar[p] = {
            rate: 100 * e / this.protocolStats[p],
            count: e,
            avg: Math.round(d / e),
            sheetByDay: d / t
          }
        }
      )

      const final = ice.freeze(
        {
          protocolDistribution: result.protocolDistribution,
          regionalDistribution: result.regionalDistribution,
          establishmentSizeDistribution: establishmentsBuckets,
          protocolRadar: protocolRadar,
          evolution: evolution,
          bactSheetsDistribution: bactSheetsBuckets
        },
        2
      )
      return final
    },

    evolution: function () {
      return impl.evolution(this.year, this.flatList.evolution)
    },

    selectionEvolution: function () {
      return impl.evolution(this.year, this.selectionFlatList.evolution)
    },

    protocolDistribution: function () {
      return impl.protocolDistribution(
        this.year, this.flatList.protocolDistribution
      )
    },

    bactSheetsDistribution: function () {
      return impl.bactSheetsDistribution(this.flatList.bactSheetsDistribution)
    },

    selectionProtocolDistribution: function () {
      return impl.protocolDistribution(
        this.year,
        this.selectionFlatList.protocolDistribution
      )
    },

    regionalDistribution: function () {
      const d = this.flatList.regionalDistribution
      return impl.regionalDistribution(d.labels, d.data)
    },

    regionalEstablishmentDistribution: function () {
      const d = this.flatList.regionalDistribution
      return impl.regionalEstablishmentDistribution(d.labels, d.establishments)
    },

    establishmentCount: function () {
      return impl.establishmentCount(this.year, this.flatList.protocolRadar)
    },

    protocolRadar: function () {
      return impl.protocolRadar(this.year, this.flatList.protocolRadar)
    },

    establishmentSizeDistribution: function () {
      return impl.establishmentSizeDistribution(
        this.flatList.establishmentSizeDistribution
      )
    },

    sheetByEstablishment: function () {
      return impl.sheetByEstablishment(this.year, this.flatList.protocolRadar)
    }
  },

  components: {
    'chart': chart
  },

  methods: {
    setError: function (text) {
      this.error.error = true
      this.error.text = text
    },

    refreshData: function () {
      this.refreshing = true
      this.error.error = false
      const vm = this
      this.$store.dispatch('surveillances/all', this.year).then(
        response => {
          if (response.data.err == null) {
            vm.refreshSheets()
          } else {
            vm.setError(response.data.err)
            vm.refreshing = false
          }
        }
      ).catch(e => {
        vm.refreshing = false
        vm.setError(e.toString())
      })
    },

    refreshSheets: function () {
      const vm = this
      const year = parseInt(this.year)
      const begin = new Date(year - 1, 11, 1, 12)
      const end = moment(this.endDate).add(1, 'day').endOf('day')

      this.$store.dispatch(
        'bosheet/all',
        {
          b: begin,
          e: end.toDate()
        }
      ).then(
        response => {
          if (response.data.err != null) {
            vm.setError(response.data.err)
          }
          vm.refreshing = false
        }
      ).catch(e => {
        vm.setError(e.toString())
        vm.refreshing = false
      })
    },

    setEndDate: function () {
      this.endDate =
        this.year === '2019'
          ? `08/23/2019` : moment().endOf('day')
    }
  },

  mounted: function () {
    this.setEndDate()
    this.refreshData()
  },

  watch: {
    year: function () {
      this.setEndDate()
      this.refreshData()
    }
  }
}
</script>

<style scoped lang="less">
.chart-container {
    padding: 2rem;
}

.input-label {
    margin-right: 1rem;
}

h3 {
  margin-top: 0rem;
}
</style>
